/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetProfilePhotoBulkInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_profile_photo_bulk_internal.pb'
import {GetProfilePhotoBulkInternalResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_profile_photo_bulk_internal.pb'


export const getProfilePhotoBulkInternal = (request: GetProfilePhotoBulkInternalRequest, options?: CashRequestOptions) => post<GetProfilePhotoBulkInternalRequest, GetProfilePhotoBulkInternalResponse>("/2.0/cash/get-profile-photo-bulk-internal", request, {...options, rejectOnError: true })